import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-950 text-slate-400 py-12 px-4 text-center text-sm pb-28 md:pb-12" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <p className="mb-4 font-bold text-slate-300 text-lg" data-id="element-79">
          OrthoRelief México
        </p>
        <p className="mb-6" data-id="element-80">
          Este sitio no es parte de Facebook ni Meta Platforms, Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera. FACEBOOK
          es una marca registrada de META PLATFORMS, Inc.
        </p>
        <p className="mb-6" data-id="element-81">
          Descargo de responsabilidad médica: La información en este sitio web
          no pretende sustituir el consejo, diagnóstico o tratamiento médico
          profesional. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener sobre una
          condición médica.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-82">
          <a href="#" className="hover:text-white transition-colors" data-id="element-83">
            Términos de Servicio
          </a>
          <span data-id="element-84">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-85">
            Política de Privacidad
          </a>
          <span data-id="element-86">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-87">
            Contacto
          </a>
        </div>
        <p data-id="element-88">
          © {new Date().getFullYear()} OrthoRelief. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}